import PropTypes from 'prop-types';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { AlertWatchlistComponentTableRow } from '../alertWatchlistComponentTableRow/AlertWatchlistComponentTableRow';
// import { sortAlerts } from '../utils/alertSortingAlgo';
import { useKeyPress } from '../utils/useKeyPress';
import { useAlertsStore } from '../../../../../../stores/websocketStore/_alertsStore';
import { simplifiedAlertSortingAlgo } from '../utils/simplifiedAlertSortingAlgo';

export const AlertWatchlistComponentTableBody = observer(
  ({
    watchlistName,
    selectedAlert,
    setSelectedAlert,
    parentNode,
    layoutStore,
    moduleId,
  }) => {
    const alertStore = useAlertsStore();

    const watchlist =
      alertStore.alertTradePlansByWatchlistName[watchlistName] ?? null;
    const watchlistArray = Object.keys(watchlist || {}) ?? null;
    const filteredArray =
      watchlistArray
        ?.filter((id) => id !== 'groupNumber')
        .sort((a, b) => simplifiedAlertSortingAlgo(a, b, alertStore))
        .map((alertId) => (
          <AlertWatchlistComponentTableRow
            key={alertId}
            alertId={alertId}
            selectedAlert={selectedAlert}
            setSelectedAlert={setSelectedAlert}
          />
        )) ?? null;
    const handleArrowKeyPress = (event) => {
      event.preventDefault();
      if (selectedAlert && layoutStore.currentFocusedModule === moduleId) {
        const index = filteredArray.findIndex(
          (item) => item.key === selectedAlert
        );
        if (event.key === 'ArrowUp') {
          if (index !== 0) {
            const newIndex = index - 1;
            setSelectedAlert(filteredArray[newIndex].key);
          }
        } else {
          const arrayLength = filteredArray.length;
          if (index !== arrayLength - 1) {
            const newIndex = index + 1;
            setSelectedAlert(filteredArray[newIndex].key);
          }
        }
      }
    };
    useKeyPress(
      ['ArrowUp', 'ArrowDown'],
      handleArrowKeyPress,
      parentNode.current
    );
    if (!filteredArray) return null;
    return <tbody className="noDragTag">{filteredArray}</tbody>;
  }
);
AlertWatchlistComponentTableBody.propTypes = {
  watchlistName: PropTypes.any,
};
